export default __webpack_public_path__ + "img/2_11-b51db13b.png";